<template>
  <base-section
    id="follow-social"
    class="secondary"
    dark
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <base-section-heading
        title="Social Media"
      >
        Follow us on our ETS23 official social channels to stay up to date with all the news!
      </base-section-heading>
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <a
              :href="card.extlink"
              target="_blank"
              style="text-decoration: none !important"
            >
              <base-info-card
                align="center"
                dark
                v-bind="card"
              />
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFollowSocial',

    data: () => ({
      cards: [
        {
          icon: 'mdi-facebook',
          title: 'Facebook',
          extlink: 'https://www.facebook.com/ETS-Conference-669254046517645/',
        },
        {
          icon: 'mdi-twitter',
          title: 'Twitter',
          extlink: 'https://twitter.com/IEEE_ETS',
        },
        {
          icon: 'fa-brands fa-telegram',
          title: 'Telegram',
          extlink: 'https://t.me/+sQRC8zgIBMc0MDA0',
        },
        {
          icon: 'mdi-linkedin',
          title: 'LinkedIn',
          extlink: 'https://www.linkedin.com/groups/8794779/',
        },
      ],
    }),
  }
</script>
